<template>
  <div>
    <div class="row">
      <div class="col-12">
        <page-header
          :page="page"
          @onReturn="() => $router.back()"
          :has-return="true"
       />
      </div>
    </div>
    <div class="row">
      <div class="col">
        <filter-manager
          :display-advanced="false"
          class="search-bar"
          items-container-class="flex-wrap"
          search-icon="fa fa-sync"
          search-text="Procesar"
          search-container-class="btn-process"
          v-model="model.search.filters"
          :filters="filterManagerConfig"
          @search="onHandlerSearch"
          ref="filterRef"
        />
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from 'PageHeader'
import FilterManager from 'FilterManager'
import codeService from '@/services/api/code.api'
import therapyApi from '@/services/api/thrpy.api'
import appointmentsServices from '@/services/api/appointments.api'
import disbursementStatuses from '@/utils/constants/disbursementStatus'
import reportApi from '@/modules/report/api'
import DocumentsService from '@//modules/report/document'

export default {
  components: {
    PageHeader,
    FilterManager,
  },
  data: () => 
  ({
    page: {
      icon: 'fas fa-chart-pie',
      title: 'Informe Reembolsos Sometidos',
      routes: ["Inicio", "Informes Generales", "Informe Reembolsos Sometidos"]
    },
    model: {
      search: {
        collections: {
          academicYears: [],
          periods: [],
          statuses: [],
        },
        filters: {
          academicYear: null,
          period: null,
          status: null,
          studentSie: null,
        },
      },
    },
  }),
  computed: {
    filterManagerConfig() {
    return [
      {
        name: 'academicYear',
        component: 'custom-drop-down',
        fieldKey: 'id',
        fieldName: 'name',
        label: 'Año Fiscal',
        placeholder: 'Seleccionar',
        error: "Favor seleccionar un año fiscal.",
        validations: "required",
        class: "col-md-3",
        clearable: false,
        onChanged: this.onChangeAcademicYear,
        options: this.model.search.collections.academicYears,
        value: this.model.search.filters.academicYear,
      },
      {
        name: 'period',
        component: 'custom-drop-down',
        fieldKey: 'id',
        fieldName: 'name',
        label: 'Periodo',
        placeholder: 'Seleccionar',
        clearable: true,
        class: "col-md-3",
        options: this.model.search.collections.periods,
        value: this.model.search.filters.period,
        disabled: this.model.search.collections.periods.length <= 0,
      },
      {
        name: 'status',
        component: 'custom-drop-down',
        fieldKey: 'id',
        fieldName: 'name',
        label: 'Estatus',
        placeholder: 'Seleccionar',
        clearable: true,
        class: "col-md-3",
        options: this.model.search.collections.statuses,
        value: this.model.search.filters.status,
        disabled: this.model.search.collections.statuses.length <= 0,
      },
      {
        name: 'studentSie',
        component: 'CustomInput',
        fieldKey: 'id',
        fieldName: 'name',
        class: "col-md-3",
        value: this.model.search.filters.studentSie,
        label: 'Número de SIE',
        placeholder: 'Escriba Número de SIE',
        type: 'text',
        maskType: 'Number',
        dynamicProps: {
          maxlength: '8',
        },
      },
    ]},
  },
  async mounted() {
    await this.setFilters();
  },
  methods: {
    async setFilters() {
      const { data: years } = await therapyApi.getDisbursementAcademicYears();
      this.model.search.collections.academicYears = [...years];

      await this.getDisbursementStatuses();
    },
    async onChangeAcademicYear() {
      await this.getPeriods();
    },
    async getDisbursementStatuses() {
      const { data: statuses } = await codeService.getDisbursementRequestStatuses();
      const filteredStatuses = statuses.filter(s => s.id !== disbursementStatuses.New);
      this.model.search.collections.statuses = [...filteredStatuses];
    },
    async getPeriods() {
      await appointmentsServices.getAppointmentsFilters({ academicYearId: this.model.search.filters.academicYear?.id})
        .then(res => { 
          this.model.search.collections.periods = res.data;
        });
    },
    async onHandlerSearch() {
      if (this.model.search.filters.academicYear !== null &&  this.model.search.filters.academicYear !== undefined) {
        this.process();
      }
    },
    async process() {
      const payload = {
        academicYearId: this.model.search.filters.academicYear?.id,
        statusId: this.model.search.filters.status?.id,
        monthNumber: this.model.search.filters.period?.id,
        studentSie: this.model.search.filters.studentSie,
      };

      reportApi
        .getReport('submitteddisbursements', payload)
        .then((res) => DocumentsService.Download(res.data));
    },
  },
}
</script>